import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const MicrowaveIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "MicrowaveIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M21.5283 5.78043H4.45033C3.73735 5.78043 3.15723 6.36055 3.15723 7.0741V17.6457C3.15723 18.3592 3.73735 18.9393 4.45033 18.9393H21.5283C22.2413 18.9393 22.8214 18.3592 22.8214 17.6457V7.0741C22.8214 6.36055 22.2413 5.78043 21.5283 5.78043ZM21.8616 17.6457C21.8616 17.8295 21.7122 17.9795 21.5283 17.9795H18.7552V6.7408H21.5283C21.7122 6.7408 21.8616 6.89027 21.8616 7.0741V17.6457ZM17.7954 6.74081V17.979H4.45033C4.2665 17.979 4.11703 17.8295 4.11703 17.6457V7.0741C4.11703 6.89027 4.2665 6.7408 4.45033 6.7408L17.7954 6.74081Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M20.3084 7.40738C19.8196 7.40738 19.4219 7.80482 19.4219 8.29388C19.4219 8.78294 19.8196 9.18038 20.3084 9.18038C20.7974 9.18038 21.1952 8.78294 21.1952 8.29388C21.1952 7.80482 20.7974 7.40738 20.3084 7.40738Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M20.3084 9.84683C19.8196 9.84683 19.4219 10.2443 19.4219 10.7333C19.4219 11.2224 19.8196 11.6198 20.3084 11.6198C20.7974 11.6198 21.1952 11.2224 21.1952 10.7333C21.1952 10.2443 20.7974 9.84683 20.3084 9.84683Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M20.3084 12.2863C19.8196 12.2863 19.4219 12.6837 19.4219 13.1728C19.4219 13.6618 19.8196 14.0593 20.3084 14.0593C20.7974 14.0593 21.1952 13.6618 21.1952 13.1728C21.1952 12.6837 20.7974 12.2863 20.3084 12.2863Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M6.07658 16.4985H15.8355C16.1001 16.4985 16.3154 16.2831 16.3154 16.0186V8.69978C16.3154 8.4352 16.1001 8.21988 15.8355 8.21988H6.07658C5.812 8.21988 5.59668 8.43521 5.59668 8.69978V16.0186C5.59668 16.2831 5.81201 16.4985 6.07658 16.4985ZM6.55648 15.5387V9.17969H15.3556V15.5387H6.55648Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default MicrowaveIcon;
